import React from 'react'
import styles from './CurrentTicket.module.css'

function OutgoingMessage ({ message }) {
  return (
    <div className={styles.ticketItemWrapper} style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <div className={styles.ticketItem}>
        <div className={styles.ticketItemTitle} style={{ textAlign: 'right' }}>Я</div>
        <div className={styles.ticketItemContent}>{message}</div>
      </div>
    </div>
  )
}

export default OutgoingMessage
